import { createIcon } from './createIcon';

import ArrowRight from './imgs/arrow-right.svg?component';
export const ArrowRightIcon = createIcon(ArrowRight);

import Check from './imgs/check.svg?component';
export const CheckIcon = createIcon(Check);

import CheckAnimated from './imgs/check-animated.svg?component';
export const CheckAnimatedIcon = createIcon(CheckAnimated);

import CheckboxOff from './imgs/checkbox-off.svg?component';
export const CheckboxOffIcon = createIcon(CheckboxOff);

import CheckboxOn from './imgs/checkbox-on.svg?component';
export const CheckboxOnIcon = createIcon(CheckboxOn);

import Close from './imgs/close.svg?component';
export const CloseIcon = createIcon(Close);

import Comment from './imgs/comment.svg?component';
export const CommentIcon = createIcon(Comment);

import HeartOff from './imgs/heart-off.svg?component';
export const HeartOffIcon = createIcon(HeartOff);

import HeartOn from './imgs/heart-on.svg?component';
export const HeartOnIcon = createIcon(HeartOn);

import Invisible from './imgs/invisible.svg?component';
export const InvisibleIcon = createIcon(Invisible);

import LongArrowRight from './imgs/long-arrow-right.svg?component';
export const LongArrowRightIcon = createIcon(LongArrowRight);

import Meatballs from './imgs/meatballs.svg?component';
export const MeatballsOffIcon = createIcon(Meatballs);

import Pencil from './imgs/pencil.svg?component';
export const PencilIcon = createIcon(Pencil);

import Refresh from './imgs/refresh.svg?component';
export const RefreshIcon = createIcon(Refresh);

import Share from './imgs/share.svg?component';
export const ShareIcon = createIcon(Share);

import Search from './imgs/search.svg?component';
export const SearchIcon = createIcon(Search);

import Start from './imgs/start.svg?component';
export const StartIcon = createIcon(Start);

import Trash from './imgs/trash.svg?component';
export const TrashIcon = createIcon(Trash);
